var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-form-group"},[_c('BaseSwitcher',{attrs:{"value":_vm.form.opened,"label":"View group as","hint":"Set default view as open or closed"},on:{"input":_vm.setView}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23a71b76","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/sub-forms/SubFormGroup.vue
// module id = 749
// module chunks = 0